import { render, staticRenderFns } from "./termOfUse_en.vue?vue&type=template&id=d31f58e8"
import script from "./termOfUse_en.vue?vue&type=script&lang=js"
export * from "./termOfUse_en.vue?vue&type=script&lang=js"
import style0 from "./termOfUse_en.vue?vue&type=style&index=0&id=d31f58e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports